import { render, staticRenderFns } from "./BlocoPoliticaDeTroca.vue?vue&type=template&id=e87b1c98&scoped=true&"
import script from "./BlocoPoliticaDeTroca.vue?vue&type=script&lang=ts&"
export * from "./BlocoPoliticaDeTroca.vue?vue&type=script&lang=ts&"
import style0 from "./BlocoPoliticaDeTroca.vue?vue&type=style&index=0&id=e87b1c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87b1c98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VExpandTransition,VSwitch,VTextarea})
